import { Capacitor } from '@capacitor/core';
import type { MessageKey } from '../../i18n/i18n';
import { getPurchasesAdapter } from '../../native/purchasesAdapter';

// Which store the purchase wording names (emulator walkthrough 2026-10-16: on Android every buy button
// read 「在 App Store 购买」 and the terms talked about the Apple ID). The plain dictionary entries are
// the iOS wording and stay exactly as approved; Android reads the `.android` entry of the same key, and the
// web version's own payment lane (item 39, RevenueCat Web Billing) the `.web` entry. The development server's
// simulated store keeps the iOS wording, as before.
export type StoreCopyPlatform = 'ios' | 'android' | 'web';

export function storeCopyPlatform(): StoreCopyPlatform {
  if (Capacitor.getPlatform() === 'android') return 'android';
  if (!Capacitor.isNativePlatform() && getPurchasesAdapter().platform === 'web') return 'web';
  return 'ios';
}

const ANDROID_VARIANTS: ReadonlySet<MessageKey> = new Set<MessageKey>([
  'billing.buy',
  'billing.buying',
  'billing.purchasePending',
  'billing.notConfiguredBody',
  'billing.restoreEmpty',
  'billing.manageBody',
  'billing.offerCodeBody',
  'billing.offerCodeWaiting',
  'billing.offerCodeNotDetected',
  'billing.terms1',
  'billing.terms5',
  'billing.terms6'
]);

// The web has no offer codes (it has its own redemption codes), so those three have no web entry.
const WEB_VARIANTS: ReadonlySet<MessageKey> = new Set<MessageKey>([
  'billing.buy',
  'billing.buying',
  'billing.purchasePending',
  'billing.notConfiguredBody',
  'billing.restoreEmpty',
  'billing.manageBody',
  'billing.terms1',
  'billing.terms5',
  'billing.terms6'
]);

export function storeKey(key: MessageKey, platform: StoreCopyPlatform = storeCopyPlatform()): MessageKey {
  if (platform === 'android' && ANDROID_VARIANTS.has(key)) return `${key}.android` as MessageKey;
  if (platform === 'web' && WEB_VARIANTS.has(key)) return `${key}.web` as MessageKey;
  return key;
}
